import {
  TableDataColumn,
  TableHeaderColumn,
} from "~/src/components/common/tables/Table";
import { chakraFactory } from "~/src/lib/chakra-ui";

const DESCRIPTION_COLUMN_FLEX = 5;
const DESCRIPTION_COLUMN_MIN_WIDTH = "400px";

export const StyledDescriptionHeaderColumn = chakraFactory(TableHeaderColumn, {
  baseStyle: {
    flex: DESCRIPTION_COLUMN_FLEX,
    minWidth: DESCRIPTION_COLUMN_MIN_WIDTH,
  },
});

export const StyledDescriptionDataColumn = chakraFactory(TableDataColumn, {
  baseStyle: {
    flex: DESCRIPTION_COLUMN_FLEX,
    minWidth: DESCRIPTION_COLUMN_MIN_WIDTH,
  },
});
